// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1p46j","title":"InfoRow_title__1g-b0"};